import { DateTimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";

export type TruxSimpleDateTimeFieldProps = {
  value?: string,
  label?: string,
  disabled?: boolean,
  limitWidth?: boolean,
  timezone: string,
  onChange: (date: string) => void
}

export default function TruxSimpleDateTimeField({ value, onChange, timezone, disabled = false, label, limitWidth = true }: TruxSimpleDateTimeFieldProps) {
  return <DateTimePicker
    views={['year', 'month', 'day', 'hours', 'minutes', 'seconds']}
    label={label}
    timezone={timezone}
    value={!value ? null : dayjs(value).tz(timezone)}
    onChange={(date) => onChange(date?.format() as any)}
    disabled={disabled}
    slotProps={{
      textField: {
        fullWidth: true,
        size: "small"
      },
    }}
    sx={{
      maxWidth: limitWidth ? { md: 180 } : undefined,
      width: "100%"
    }}
  />
}